import { Pipe, PipeTransform } from '@angular/core';
import { tz } from '@macs-frontend/core/utils/date-fns';
import { DateInput, toDate } from '@macs-frontend/core/utils/date-utils';
import { function as F, option as O } from 'fp-ts';

@Pipe({ name: 'zonedDateToUTC', pure: false })
export class ZonedDateToUTCPipe implements PipeTransform {
  constructor() {}

  public transform<T extends DateInput | null | undefined>(
    value: T,
  ): T extends DateInput ? Date : undefined {
    return F.pipe(
      value,
      O.fromNullable,
      O.fold(
        () => undefined as T extends DateInput ? Date : undefined,
        value =>
          F.pipe(value, toDate, tz.zonedTimeToUtc('UTC')) as T extends DateInput
            ? Date
            : undefined,
      ),
    );
  }
}
